import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class MetadataService {
  static getAll() {
    return ApiHelper.fetch(`${API.URL + API.METADATA}`)
  }

  static getCompanies() {
    return ApiHelper.fetch(`${API.URL + API.METADATA}/companies`)
  }

  static getCompany(companySlug) {
    return ApiHelper.fetch(`${API.URL + API.METADATA}/companies/${companySlug}`)
  }
}

export default MetadataService
